<template>
  <div class="homepage-container">
    <app-header></app-header>
    <!-- <youtubeVideo></youtubeVideo> -->

    <section class="section" id="aboutus">
      <div class="container">
        <div class="columns">
          <div class="column is-10-fullhd is-offset-1-fullhd">
            <div class="content has-text-centered has-text-primary">
              <br>
              <h4 class="has-text-primary is-uppercase">{{ texts.introTitle }}</h4>
              <br>
              <br>
            </div>
          </div>
        </div>
        <div class="customNavigationContainer is-hidden-touch">
          <a class="customNavigation previous"><img ref="presentationCarouselPrev" @click="slideCarouselStep('prev')"
              :src="presentationPrevButtonSrc" alt="" /></a>
          <a class="customNavigation next"><img ref="presentationCarouselNext" @click="slideCarouselStep('next')"
              :src="presentationNextButtonActiveSrc" alt="" /></a>
        </div>

        <div class="columns is-multiline">
          <div class="column is-12-touch is-5-desktop is-widescreen-4 is-5-fullhd">
            <p class="has-text-primary is-normal" v-html="texts.introText"></p>
          </div>
          <div class="column carouselColumn">

            <carousel :per-page="1" :mouse-drag="true" :minSwipeDistance="1" class="" :loop="false"
              ref="presentationCarousel" :paginationPadding="5" :paginationSize="7">
              <slide v-for="image in presentationImages" :key="image.src" class="">
                <figure class="image">
                  <img class="" :src="image.src" alt="tiny house trailer">
                </figure>
              </slide>
            </carousel>

          </div>
        </div>
      </div>
    </section>

    <team></team>




    <section class="hero divider strip-picture">
      <div class="hero-body ">

        <div class="container">

        </div>
      </div>
    </section>


    <section class="section is-large products-section" id="products">
      <div class="container ">
        <div class="columns">
          <div class="column is-10-fullhd is-offset-1-fullhd products-title">
            <div class="content">
              <h4 class="is-uppercase has-text-centered has-text-primary">{{ texts.productsSectionTitle }}</h4>
            </div>
          </div>
        </div>
        <div class="column is-10-fullhd is-offset-1-fullhd">
          <div class="columns columns-products is-10-fullhd is-offset-1-fullhd is-multiline"
            style="gap: 12%; justify-content: center;">
            <div class="column is-one-quarter" style="margin: 24px 0;">
              <router-link :to="'/' + $i18n.locale + '/tinyhousetrailer'" class="products-anchor">
                <figure class="image columns is-vcentered image-wrapper light-blue">
                  <p>{{ texts.firstProductTitle }}</p>
                  <img class="is-rounded" src="/images/tiny-house-trailers-2025/tiny-trailer-dot.jpg" />
                </figure>
              </router-link>
            </div>
            <!-- <div class="column custom-gap"></div> -->
            <div class="column is-one-quarter" style="margin: 24px 0;">
              <router-link :to="'/' + $i18n.locale + '/boat'" class="products-anchor">
                <figure class="image columns is-vcentered image-wrapper dark-blue">
                  <p>{{ texts.secondProductTitle }}</p>
                  <img class="is-rounded" src="/images/csonakszallitok/boat-dot.jpg" />
                </figure>
              </router-link>
            </div>
            <!-- <div class="column custom-gap"></div> -->
            <div class="column  is-one-quarter" style="margin: 24px 0;">
              <router-link :to="'/' + $i18n.locale + '/goodtransport'" class="products-anchor">
                <figure class="image columns is-vcentered image-wrapper orange">
                  <p>{{ texts.thirdProductTitle }}</p>
                  <img class="is-rounded" src="/images/aruszallitok/machine-transporter-dot.jpg" />
                </figure>
              </router-link>
            </div>
            <!-- <div class="column custom-gap"></div> -->
            <div class="column  is-one-quarter" style="margin: 24px 0;">
              <router-link :to="'/' + $i18n.locale + '/detachabletrailers'" class="products-anchor">
                <figure class="image columns is-vcentered image-wrapper light-blue">
                  <p>{{ texts.fourthProductTitle }}</p>
                  <img class="is-rounded" src="/images/detachable-trailers-2025-copy/detachable-dot.jpg" />
                </figure>
              </router-link>
            </div>
            <!-- <div class="column custom-gap"></div> -->
            <div class="column  is-one-quarter" style="margin: 24px 0;">
              <router-link :to="'/' + $i18n.locale + '/containertrailers'" class="products-anchor">
                <figure class="image columns is-vcentered image-wrapper dark-blue">
                  <p>{{ texts.fifthProductTitle }}</p>
                  <img class="is-rounded" src="/images/container-trailers-2025/container-trailer-dot.jpg" />
                </figure>
              </router-link>
            </div>
            <div class="column  is-one-quarter" style="margin: 24px 0;">
              <router-link :to="'/' + $i18n.locale + '/extraoptions'" class="products-anchor">
                <figure class="image columns is-vcentered image-wrapper orange">
                  <p>{{ texts.sixthProductTitle }}</p>
                  <img class="is-rounded" src="/images/extra-options-2025/Stabilizer triangle.jpg" />
                </figure>
              </router-link>
            </div>
          </div>
        </div>
      </div>
    </section>


    <section class="section is-large products-section" id="service">
      <div class="container ">
        <div class="columns">
          <div class="column is-10-fullhd is-offset-1-fullhd products-title">
            <div class="content">
              <h4 class="is-uppercase has-text-centered has-text-primary">{{ texts.service.sectionTitle }}</h4>
            </div>
          </div>
        </div>
        <div class="column is-8-fullhd is-offset-2-fullhd">
          <p class="has-text-primary" v-html="texts.service.description"></p>
        </div>
      </div>
    </section>

    <section class="section certificates-section" id="ourCertificates">
      <div class="container ">
        <div class="columns">
          <div class="column is-10-fullhd is-offset-1-fullhd products-title">
            <div class="content">
              <h4 class="is-uppercase has-text-centered has-text-primary">{{ texts.ourCertificatesSectionTitle }}</h4>
            </div>
          </div>
        </div>
        <div class="columns certificateImages is-multiline is-variable is-4-desktop">
          <div class="column is-8-tablet is-6-desktop is-offset-2-tablet is-offset-3-desktop "
            style="align-items: center">
            <div class="certificateCard">
              <figure class="image is-vcentered">
                <img class="is-rounded" src="../assets/images/ourcertificates/imageedit_4_7918630074.png">
              </figure>
              <p class="has-text-centered has-text-weight-bold has-text-primary">{{ texts.ourCertificateCOC }}</p>
            </div>
          </div>
          <div class="column certificate3 is-4-tablet is-3-desktop is-offset-2-tablet is-offset-3-desktop"
            style="align-items: center">
            <div class="certificateCard rar">
              <figure class="image is-vcentered ">
                <img class="is-rounded" src="../assets/images/ourcertificates/RAR4.png" style="">
              </figure>
              <p class="has-text-centered has-text-weight-bold has-text-primary">{{ texts.ourCertificateRAR }}</p>
            </div>
          </div>
          <div class="column certificate2 is-4-tablet is-3-desktop " style="align-items: center">
            <div class="certificateCard">
              <figure class="image is-96x96 is-vcentered ">
                <img class="is-rounded" src="../assets/images/ourcertificates/TS_TS_f_4c.png" style="">
              </figure>
              <p class="has-text-centered has-text-weight-bold has-text-primary">Tüv Süd <br> ISO 9606-1</p>
            </div>
          </div>

        </div>


      </div>
    </section>
    <app-footer></app-footer>
  </div>
</template>
<script>
import AppHeader from './AppHeader.vue'
import AppFooter from './AppFooter.vue'
import YoutubeVideo from './YoutubeVideo.vue'
import Team from './Team.vue'
import { Carousel, Slide } from "vue-carousel";


export default {
  data() {
    return {
      presentationPrevButtonSrc: require('../assets/images/arrow_back_gray.svg'),
      presentationPrevButtonActiveSrc: require('../assets/images/arrow_back_black.svg'),
      presentationNextButtonSrc: require('../assets/images/arrow_next_gray.svg'),
      presentationNextButtonActiveSrc: require('../assets/images/arrow_next_black.svg'),
      presentationImages: [
        {
          "src": require('../assets/images/presentation/presentation01.jpg')
        },
        {
          "src": require('../assets/images/presentation/presentation02.jpg')
        },
        {
          "src": require('../assets/images/presentation/presentation03.jpg')
        },
        {
          "src": require('../assets/images/presentation/presentation04.jpg')
        },
        {
          "src": require('../assets/images/presentation/presentation05.jpg')
        },
        {
          "src": require('../assets/images/presentation/presentation06.jpg')
        },
        {
          "src": require('../assets/images/presentation/presentation07.jpg')
        },
        {
          "src": require('../assets/images/presentation/presentation08.jpg')
        },
        {
          "src": require('../assets/images/presentation/presentation10.jpg')
        },
        {
          "src": require('../assets/images/presentation/presentation11.jpg')
        },
        {
          "src": require('../assets/images/presentation/presentation12.jpg')
        },

      ]
    }
  },
  components: {
    'appHeader': AppHeader,
    'appFooter': AppFooter,
    'youtubeVideo': YoutubeVideo,
    'team': Team,
    Carousel,
    Slide,
  },
  computed: {
    texts() {
      return this.$t("homePage")
    },
    presentationCurrentIndex: {
      cache: false,
      get() {
        return this.$refs["presentationCarousel"] ? this.$refs["presentationCarousel"].currentPage : 0;
      }
    }
  },
  methods: {
    slideCarouselStep(value) {

      const carousel = this.$refs["presentationCarousel"];
      const prevButton = this.$refs['presentationCarouselPrev'];
      const nextButton = this.$refs['presentationCarouselNext'];
      const currentPage = carousel.currentPage;
      const pageCount = carousel.pageCount;
      const carouselLength = this.presentationImages.length;
      if (value == "prev") {
        carousel.goToPage(currentPage - 1)
      } else {
        this.presentationCurrentIndex < carouselLength - 1 ? carousel.goToPage(currentPage + 1) : '';
      }

      this.presentationCurrentIndex == carouselLength - 1 ? nextButton.src = this.presentationNextButtonSrc : nextButton.src = this.presentationNextButtonActiveSrc;
      this.presentationCurrentIndex == 0 ? prevButton.src = this.presentationPrevButtonSrc : prevButton.src = this.presentationPrevButtonActiveSrc;
    }
  },
}
</script>
<style lang="scss" scoped>
.hebo {
  color: #cfdbd6;
}

.homepage-container {
  .products-section {
    padding-top: 2rem;
    padding-bottom: 6rem;
  }

  .certificates-section {
    padding-top: 2rem;
    padding-bottom: 14rem;
  }
}

.column.certificate2 {
  display: flex;
  flex-direction: column;
  align-items: center;

  @media(max-width: 768px) {}

  img {
    max-width: 300px;
    height: auto;
  }
}

#aboutus p {
  font-style: italic;
}

.trailers {
  color: #ef6d22;
  font-style: italic;
}


.products-anchor {
  img {
    transition: 0.3s ease-out;
  }

  .image {
    // padding: 24px 0;
  }
}

.products-anchor:hover img,
.products-anchor:hover .image-wrapper::after {
  transform-origin: center 58%;
  transition: 0.3s ease-out;
  transform: scale(1.02);

}

.customNavigationContainer {
  text-align: end;
  margin: 0 0 1rem 0;

  .previous {
    margin-right: 2rem;
  }
}

.strip-picture {
  height: 13rem;
  background-repeat: no-repeat;
  background-image: url('../assets/images/strip.png');
  background-position: center;
}

.products-title {
  padding: 3rem 0;
}

.certificates-title {
  padding: 3rem 0 6rem 0;
}

.custom-gap {
  min-height: 5vh;
}

.image p {
  position: absolute;
  right: 0;
  left: 0;
  text-align: center;
  color: #fff;
  z-index: 35;
  transition: 0.3s ease-out;
  text-transform: uppercase;
  font-size: 1.1em;
  max-width: 80%;
  margin: 0 auto;
  top: 50%;
  transform: translateY(-50%);
}

.certificateImages .column {
  display: flex;
  align-content: center;
}



.certificateCard {
  width: 100%;
  height: 100%;
  box-shadow: 0px 0px 20px rgba(0, 0, 0, 0.15);
  border-radius: 4px;
  display: flex;
  justify-content: space-around;
  align-items: center;
  flex-direction: column;
  min-height: 200px;

  &.rar {
    img {
      max-height: 75px;
    }
  }
}

.is-normal {
  font-style: normal !important;
}

.has-text-primary a,
.has-text-primary strong {
  color: $primary
}

.image-wrapper img {
  display: block;
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 9999999px;
}

.image-wrapper::after {
  transition: 0.3s ease-out;
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  border-radius: 50%;
}

.image-wrapper.orange::after {
  background: rgba(229, 106, 37, 0.8);

}

.image-wrapper.dark-blue::after {
  background: rgba(0, 50, 61, 0.8);

}

.image-wrapper.light-blue::after {
  background: rgba(30, 110, 122, 0.8);

}

.carouselColumn {
  width: 50%;
}

@media(max-width: 768px) {
  .carouselColumn {
    width: 100%;
  }
}
</style>
